import JourneyToDonut from "./JourneyToDonut";
import Runnerz from "./Runnerz";
import NewYork from "./NewYork";

const queryParams = new URLSearchParams(window.location.search);
const runMode = queryParams.get("mode");

export default function IPXContents({ipxProjectKey}) {
  return (
    <>
      {runMode === "play" && (ipxProjectKey === "DONUT_DRIVE" || ipxProjectKey === "DONUT_DRIVE_TEST") && <JourneyToDonut />}
      {runMode === "play" && ipxProjectKey === "RUNNERZ" && <Runnerz />}
      {runMode === "play" && ipxProjectKey === "NEWYORK" && <NewYork />}
    </>
  );
}
